import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux";
import { userApi } from "./user.api";

/**
 * Selector to get the current user profile from RTK Query cache
 */
export const selectUserProfile = createSelector(
  (state: RootState) => state,
  (state: RootState) => {
    // Get the profile data from RTK Query cache
    const profileQuery = userApi.endpoints.getProfile.select(undefined)(
      state as RootState & { userQuery: ReturnType<typeof userApi.reducer> }
    );
    return profileQuery.data;
  }
);

/**
 * Selector to get user profile with loading state
 */
export const selectUserProfileState = createSelector(
  (state: RootState) => state,
  (state: RootState) => {
    const profileQuery = userApi.endpoints.getProfile.select(undefined)(
      state as RootState & { userQuery: ReturnType<typeof userApi.reducer> }
    );
    return {
      profile: profileQuery.data,
      isLoading: profileQuery.isLoading,
      isError: profileQuery.isError,
      error: profileQuery.error
    };
  }
);
